import { Chip, Rv } from '../../components'
import { LOGOS }    from '../../constants/logos'

export function CareerSection() {
  const bullets = [
    'Built and maintained a Selenium-Java automation framework using OOP principles, achieving a 40% reduction in QA cycle time through hybrid manual + automated testing strategies.',
    'Reduced manual testing time by 70% on the Speed Box platform by implementing robust test automation and streamlining sprint execution workflows.',
    'Executed performance testing using JMeter, validating system stability for 10,000+ simultaneous users; implemented CI/CD pipelines on cloud environments.',
    'Conducted API testing using REST Assured, Postman, and GraphQL to validate backend services; performed database testing on PostgreSQL for end-to-end data integrity.',
    'Developed cross-platform automation for web and Android using Selenium and Appium; automated pre-prod and stage suites (Regression, Sanity, Smoke) for international client Ontic (International SOS).',
    'Served as primary point of contact for client-facing testing updates, presenting sprint progress and defect summaries to Ontic stakeholders to maintain release confidence.',
  ]
  const clients = [
    { logo: LOGOS.ontic, alt: 'Ontic (International SOS)', name: 'Ontic — International SOS', desc: 'SaaS Critical Event Management' },
    { logo: null,         alt: 'Competishun',              name: 'Competishun',               desc: 'Ed-Tech learning platform' },
    { logo: null,         alt: 'Speed Box',                name: 'Speed Box',                 desc: 'SaaS Delivery Management' },
  ]
  const awards = [
    { icon: '🏅', label: 'GEM of the Month', date: 'Feb 2025' },
    { icon: '⭐', label: 'Rising Star Award', date: 'Jun 2024' },
  ]
  return (
    <section id="timeline" className="sec">
      <div className="wrap">
        <Rv className="sh"><div className="slb">Career</div><h2 className="st">Professional Experience</h2><div className="gbar"/></Rv>
        <Rv className="gls cc" style={{ maxWidth: 'none' }}>
          <div className="cdate">Sept 2023 — Oct 2025 · Gurugram, India</div>
          <a href="https://antino.com" target="_blank" rel="noopener" className="logo-wrap"><img src={LOGOS.antino} alt="Antino Labs"/></a>
          <div className="cco">Antino Labs Pvt. Ltd.</div>
          <div className="crl">Associate QA Engineer — worked across 3 major client projects, delivering end-to-end manual and automated testing across web and mobile.</div>
          <ul className="cc-bullets">{bullets.map((b, i) => <li key={i}>{b}</li>)}</ul>
          <div className="client-row">
            {clients.map(c => (
              <div key={c.name} className="client-pill">
                {c.logo ? <img src={c.logo} alt={c.alt}/> : <span className="client-dot"/>}
                <div><div className="client-name">{c.name}</div><div className="client-desc">{c.desc}</div></div>
              </div>
            ))}
          </div>
          <div className="award-row">
            {awards.map(a => <span key={a.label} className="award-chip"><span>{a.icon}</span>{a.label} — {a.date}</span>)}
          </div>
        </Rv>
      </div>
    </section>
  )
}
